<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="6">
          <el-form-item
            label="宴会类型"
            :label-width="formLabelWidth"
            prop="banquetType"
          >
            <el-select
              class="select"
              v-model="form.banquetType"
              @change="onBlur"
              remote
              placeholder="请选择宴会类型"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="客户名称"
            :label-width="formLabelWidth"
            prop="customerName"
          >
            <el-input
              class="search-input"
              v-model="form.customerName"
              placeholder="请输入客户名称"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            label="被推荐人手机号"
            :label-width="formLabelWidth"
            prop="customerPhone"
          >
            <el-input
              class="search-input"
              v-model="form.customerPhone"
              placeholder="请输入被推荐人手机号"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-delete"
              @click="resetForm('form')"
              >清空</el-button
            >
            <!-- <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            > -->
            <PermissionsBtn2
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/HotelBanquet/downLoad'"
              :form="exportForm"
            ></PermissionsBtn2>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import PermissionsBtn2 from '@/components/PermissionsBtn2';
import { encrypt } from '@/utils/encryp';
export default {
  name: 'recommendedReports',
  inject: ['reload'], // 注入reload方法
  props: {},
  components: {
    PermissionsBtn2,
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      loading: false,
      form: {
        customerPhone: '', // 被推荐人手机号
        customerName: '', // 客户名称
        banquetType: '', // 宴会类型
      },
      exportForm: {
        customerPhone: '', // 被推荐人手机号
        customerName: '', // 客户名称
        banquetType: '', // 宴会类型
        isExport: true,
      },
      options: [
        { value: 1, label: '婚宴' },
        { value: 2, label: '生日宴' },
        { value: 3, label: '商务宴' },
        { value: 4, label: '升学宴' },
        { value: 5, label: '会议' },
        { value: 0, label: '其他' },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.$emit('search', this.form);
  },
  mounted() {},
  methods: {
    // 搜索，触发父组件请求数据的方法
    onSearch() {
      this.$emit('search', this.form);
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.exportForm = {};

      this.$emit('resetForm');
    },
    onBlur() {
      let { customerName, customerPhone } = this.form;

      this.exportForm = {
        ...this.form,
        customerName: customerName ? encrypt(customerName) : '',
        customerPhone: customerPhone ? encrypt(customerPhone) : '',
      };
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
<style lang="less">
.invite-report {
  .el-table .total-row {
    background: beige;
  }
}
</style>
